import Dexie, { Table } from 'dexie';
import { LocalReceipt } from './types';

/**
 * IndexedDB база даних для зберігання локальних receipts та синхронізації
 */
class FinanceTrackerDB extends Dexie {
  receipts!: Table<LocalReceipt>;
  
  constructor() {
    super('FinanceTrackerDB');
    
    this.version(1).stores({
      receipts: 'id, syncStatus, updatedAt'
    });
  }
}

export const db = new FinanceTrackerDB();


